module.exports = __webpack_public_path__ + "img/banner-img.1590d1fd.png";